import { MULTI_INJECT_TAG } from '../constants/metadata_keys';
import { injectBase } from './inject_base';

export const multiInject = injectBase(MULTI_INJECT_TAG);
